// extracted by mini-css-extract-plugin
export default {"table-pos-tooltip":"components-parity-tooltips-table-pos-tooltip-module__table-pos-tooltip"};